// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1StorageClassParameters } from './V1StorageClassParameters';
import {
  V1StorageClassParametersFromJSON,
  V1StorageClassParametersFromJSONTyped,
  V1StorageClassParametersToJSON,
  V1StorageClassParametersToJSONTyped,
} from './V1StorageClassParameters';

/**
 *
 * @export
 * @interface V1StorageClassSettings
 */
export interface V1StorageClassSettings {
  /**
   * CoreParameters contains specs used to build the desired core PVC StorageClass.
   * @type {V1StorageClassParameters}
   * @memberof V1StorageClassSettings
   */
  coreParameters?: V1StorageClassParameters;
  /**
   *
   * @type {string}
   * @memberof V1StorageClassSettings
   */
  coreStorageClassIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof V1StorageClassSettings
   */
  jobStorageClassIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof V1StorageClassSettings
   */
  loadRestoreStorageClassIdentifier?: string;
}

/**
 * Check if a given object implements the V1StorageClassSettings interface.
 */
export function instanceOfV1StorageClassSettings(
  value: object,
): value is V1StorageClassSettings {
  return true;
}

export function V1StorageClassSettingsFromJSON(
  json: any,
): V1StorageClassSettings {
  return V1StorageClassSettingsFromJSONTyped(json, false);
}

export function V1StorageClassSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1StorageClassSettings {
  if (json == null) {
    return json;
  }
  return {
    coreParameters:
      json['coreParameters'] == null
        ? undefined
        : V1StorageClassParametersFromJSON(json['coreParameters']),
    coreStorageClassIdentifier:
      json['coreStorageClassIdentifier'] == null
        ? undefined
        : json['coreStorageClassIdentifier'],
    jobStorageClassIdentifier:
      json['jobStorageClassIdentifier'] == null
        ? undefined
        : json['jobStorageClassIdentifier'],
    loadRestoreStorageClassIdentifier:
      json['loadRestoreStorageClassIdentifier'] == null
        ? undefined
        : json['loadRestoreStorageClassIdentifier'],
  };
}

export function V1StorageClassSettingsToJSON(
  json: any,
): V1StorageClassSettings {
  return V1StorageClassSettingsToJSONTyped(json, false);
}

export function V1StorageClassSettingsToJSONTyped(
  value?: V1StorageClassSettings | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    coreParameters: V1StorageClassParametersToJSON(value['coreParameters']),
    coreStorageClassIdentifier: value['coreStorageClassIdentifier'],
    jobStorageClassIdentifier: value['jobStorageClassIdentifier'],
    loadRestoreStorageClassIdentifier:
      value['loadRestoreStorageClassIdentifier'],
  };
}
